import request from '@/utils/request'


// la lista delle request e' una custom API perche'
// mi serve anche la lista delle drugs
export function getReturnedList (entity, filters, pagination) {
  const method = 'get'
  const url = '/returned/list'

  //issue 316 - modifica date da-a
  for(var t in filters)
  {
    if (t.indexOf("_$$$_from") > -1)
    {
      var oldval1 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_from')[0]] = '>='+ oldval1
    }
    if (t.indexOf("_$$$_to") > -1)
    {
      var oldval2 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_to')[0]] = '<='+ oldval2
    }
  }
  //issue 316 - modifica date da-a

  return request({
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    },
    url, method
  })
}

export function confirmReturned(id) {
  const method = 'put'
  const url = `/returned/confirm/${id}`
  return request({
    url,
    method
  })
}

export function cancelReturned (id) {
  const method = 'post'
  const url = `/returned/cancel/${id}`
  return request({
    url,
    method
  })
}

export function requestReturned (id) {
  const method = 'post'
  const url = `/returned/request/${id}`
  return request({
    url,
    method
  })
}

export function refreshPdf (id) {
  const method = 'get'
  const url = `/returned/refreshpdf/${id}`
  return request({
    url,
    method
  })
}

export function returnableProtocols (entity, search) {
  const method = 'get'
  let url = `/returnable_proto/${search ? search : ''}`
  return request({
    url,
    method
  })
}

/**
 * nella tendina sites di un create di un return
 * mostro solo i centri che possono ritornare i farmaci
 */
export function returnableSites (entity, search, item) {
  const protocol_id = item?.protocol_id ?? false
  if (protocol_id === false) {
    return Promise.resolve({ data: [] })
  }
  const method = 'get'
  const url = `/returnable_sites/${protocol_id}/${search ?? ''}`
  return request({
    url,
    method
  })
}

export function returnableDrugs(search, protocol_id, site_id) {
  const method = 'get'
  const url = `/returnable_drugs/${protocol_id}/${site_id}/${search ? search : ''}`
  return request({
    url,
    method
  })
}

export function returnableLot (search, protocol_id, site_id, drug_id ) {
  const method = 'get'
  const url = `/returnable_lot/${protocol_id}/${site_id}/${drug_id}/${search ? search : ''}`
  return request({
    url,
    method
  })
}

  // const method = 'get'
  // const url = '/balance'
  // // const today = new Date().toISOString()
  // // const data = { protocol_id, site_id, drug_id, place: 'SITE', n_pieces: '>0',  expiration: `>${today}` }

  // const data = { protocol_id, site_id, drug_id, place: 'SITE', n_pieces: '>0' }

  // // search for lot.no
  // if (search) {
  //   if (drug_id) {
  //     data.lotto = `%${search}%`
  //   } else { // or drug name
  //     data['drug.name'] = `%${search}%`
  //   }
  // }


  // return request({
  //   url, method,
  //   headers: { 'x-filters': JSON.stringify(data) }
  // })
// }

export function disposed (returned_id, drug_id, lotto, disposed_id) {
  const method = 'put'
  const url = `/returned_has_drug/${returned_id}_${drug_id}_${lotto}`
  return request({
    url,
    method,
    data: { disposed_id }
  })
}
